import { useTranslation } from 'react-i18next'
import { openProceedMembershipModal } from '../Membership/MembershipMoreCreditsModal'
import MarkdownRenderer from '../ui/MarkdownRenderer'
import { UIDialog } from '../ui/Modal'
import Text from '../ui/Text'

function PreviewTestIneligibleDialogContent() {
  const { t } = useTranslation(['market'])
  return (
    <MarkdownRenderer className="prose prose-neutral dark:prose-invert prose-sm">
      {t('market:model.preview-test.ineligible-dialog.content')}
    </MarkdownRenderer>
  )
}

/**
 * Opens a dialog when a user attempts to use an preview test model without the required role permissions.
 */
export function openModelPreviewTestIneligibleDialog() {
  UIDialog.alert({
    dismissable: true,
    heading: (
      <Text i18nKey="market:model.preview-test.ineligible-dialog.heading" />
    ),
    content: <PreviewTestIneligibleDialogContent />,
  })
}

export function openModelEarlyAccessNeedMembershipDialog() {
  return openProceedMembershipModal({
    membershipModalProps: {
      trackingLocation: 'generation-use-early-access',
    },
    confirmationDialogProps: {
      heading: (
        <Text i18nKey="market:model.early-access.membership-dialog.heading" />
      ),
      content: (
        <Text i18nKey="market:model.early-access.membership-dialog.content" />
      ),
    },
  })
}
